<template>
  <a-layout class="fundDetails dark">
    <a-layout-header>
      <PageNav></PageNav>
    </a-layout-header>
    <a-layout-content>
      <div class="fund-detail-content flex flex-column align-center">
        <div class="content-main">
          <div class="main-card">
            <!--     -->
            <div class="flex align-center mb-24">
              <img @click="goBack" class="back-image" src="@/assets/pic-back.png">
              <span class="font-20">{{ $t('investment.product_details') }}</span>
            </div>
            <!--     -->
            <div v-if="loading" class="loading-container">
              <a-spin size="large" />
              <p>{{ $t('investment.loading') }}</p>
            </div>
            <div v-else-if="productDetail" class="flex align-center jus-bet">
              <div class="flex align-center">
                <img class="coin-image" :src="getCoinImage(productDetail.buy_currency?.symbol)">
                <span class="font-20">{{ productDetail.name }}</span>
              </div>
              <a-button @click="openSubscription">{{ $t('investment.subscribe_now') }}</a-button>
            </div>
            <!--     -->
            <div v-if="productDetail" class="info-box" type="two">
              <div class="info-con flex align-start jus-bet">
                <div class="flex flex-column align-start _column">
                  <!-- 产品总额度已隐藏 -->
                  <!-- <div class="flex align-center jus-bet">
                    <span>{{ $t('investment.total_product_limit') }}</span>
                    <span>{{ formatNumber(productDetail.total_amount) }} {{ productDetail.buy_currency?.symbol }}</span>
                  </div> -->
                  <div class="flex align-center jus-bet">
                    <span>{{ $t('investment.subscription_start_time') }}</span>
                    <span>{{ formatDate(productDetail.start_at) }}</span>
                  </div>
                  <div class="flex align-center jus-bet">
                    <span>{{ $t('investment.expected_annual_yield') }}</span>
                    <span class="color-green">{{ productDetail.eay }}%</span>
                  </div>
                  <div class="flex align-center jus-bet">
                    <span>{{ $t('investment.personal_limit') }}</span>
                    <span>{{ formatNumber(productDetail.limit_buy) }} {{ productDetail.buy_currency?.symbol }}</span>
                  </div>
                  <div class="flex align-center jus-bet" v-if="productDetail.limit_times !== undefined && productDetail.limit_times !== null">
                    <span>{{ $t('investment.personal_purchase_limit') }}</span>
                    <span v-if="productDetail.limit_times === 0">{{ $t('investment.purchase_limit_unlimited') }}</span>
                    <span v-else>{{ productDetail.limit_times }} {{ $t('investment.times') }}</span>
                  </div>
                </div>
                <div class="flex flex-column align-start _column">
                  <div class="flex align-center jus-bet">
                    <span>{{ $t('investment.minimum_subscription') }}</span>
                    <span>{{ formatNumber(productDetail.min_buy) }} {{ productDetail.buy_currency?.symbol }}</span>
                  </div>
                  <div class="flex align-center jus-bet" v-if="productDetail.limit_times !== undefined && productDetail.limit_times !== null && productDetail.limit_times > 0 && productDetail.user_purchase_count !== undefined">
                    <span>{{ $t('investment.purchase_limit_remaining') }}</span>
                    <span>{{ getRemainingPurchases() }} {{ $t('investment.times') }}</span>
                  </div>
                  <div class="flex align-center jus-bet">
                    <span>{{ $t('investment.subscription_end_time') }}</span>
                    <span>{{ formatDate(productDetail.end_at) }}</span>
                  </div>
                  <div class="flex align-center jus-bet">
                    <span>{{ $t('investment.product_term') }}</span>
                    <span>{{ productDetail.time_limit }}{{ $t('investment.days') }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!--     -->
            <div class="info-box" type="first">
              <p class="_title">{{ $t('investment.product_cycle') }}</p>
              <div class="info-con flex align-center jus-bet">
                <div class="flex flex-row align-center">
                  <span>{{ $t('investment.subscription_date') }}</span>
                  <span>{{ $t('investment.t_day') }}</span>
                </div>
                <div class="flex flex-row align-center">
                  <span>{{ $t('investment.interest_start_date') }}</span>
                  <span>{{ $t('investment.next_day_settlement_time') }}</span>
                </div>
                <div class="flex flex-row align-center">
                  <span>{{ $t('investment.redemption_date') }}</span>
                  <span>{{ $t('investment.term_end_settlement_time') }}</span>
                </div>
              </div>
            </div>
            <!--     交易规则     -->
            <div class="rule flex flex-column align-start">
              <p class="font-16">{{ $t('investment.trading_rules') }}</p>
              <div v-if="productDetail?.content" class="content-wrapper" v-html="formatContent(productDetail.content)"></div>
              <div v-else-if="$i18n && $i18n.locale" class="default-content">
                <p class="font-14 color-gray">{{ $t('investment.subscription_window_rule') }}</p>
                <p class="font-14 color-gray">{{ $t('investment.product_launch_rule') }}</p>
              </div>
            </div>
            <!--     我的申购     -->
            <!-- <div class="main-card flex flex-column align-start">
              <p class="font-16">{{ $t('investment.my_subscription') }}</p>
              <div class="column-group flex align-start jus-bet">
                <div class="card flex flex-column align-start jus-center">
                  <span class="font-16 color-gray">{{ $t('investment.total_subscription_amount') }}</span>
                  <span class="font-14 color-white mt-10"><b class="font-30">--</b> {{ productDetail?.buy_currency?.symbol || 'USDT' }}</span>
                </div>
                <div class="card flex flex-column align-start jus-center">
                  <span class="font-16 color-gray">{{ $t('investment.interest_distributed') }}</span>
                  <span class="font-14 color-white mt-10"><b class="font-30">--</b> {{ productDetail?.buy_currency?.symbol || 'USDT' }}</span>
                </div>
                <div class="card flex flex-column align-start jus-center">
                  <span class="font-16 color-gray">{{ $t('investment.remaining_available') }}</span>
                  <span class="font-14 color-white mt-10"><b class="font-30">--</b> {{ productDetail?.buy_currency?.symbol || 'USDT' }}</span>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </a-layout-content>

    <!--      立即申购弹窗-->
    <a-modal :visible="visible" align-center :render-to-body="false" 
             :mask-style="{'background':'rgba(0, 0, 0, .5)'}"
             modal-class="mode-box" :hide-title="true" :footer="false">
      <div class="modal-con">
        <div class="title-box flex align-center jus-center">
          <span class="font-20 modal-title">{{ $t('investment.subscription_confirmation') }}</span>
          <icon-close @click="visible = false" class="modal-close-btn font-bold pointer close-btn" size="24"/>
        </div>
        <div class="flex align-start jus-bet con-box">
          <div class="flex flex-column align-start con-left">
            <!-- 产品基本信息 -->
            <div class="product-info-section">
              <div class="info-item">
                <span class="label">{{ $t('investment.subscription_product') }}</span>
                <span class="value">{{ productDetail?.name || '--' }}</span>
              </div>
              <div class="info-item">
                <span class="label">{{ $t('investment.term_days') }}</span>
                <span class="value">{{ productDetail?.time_limit || '--' }} {{ $t('investment.days') }}</span>
              </div>
            </div>
            <!-- 申购金额输入 -->
            <div class="subscription-input-section">
              <div class="section-title">{{ $t('investment.subscription_amount') }}</div>
              <a-input v-model="subscriptionAmount" :placeholder="$t('investment.enter_subscription_amount')" class="subscription-input">
                <template #suffix>
                  <div class="input-suffix">
                    <span class="currency-symbol">{{ productDetail?.buy_currency?.symbol }}</span>
                    <span class="separator">|</span>
                    <span class="max-btn pointer" @click.stop="setMaxAmount">{{ $t('investment.max') }}</span>
                  </div>
                </template>
              </a-input>
              <div class="error-message" v-if="showInsufficientBalance">
                <icon-exclamation-circle-fill class="error-icon"/>
                <span>{{ $t('investment.insufficient_balance') }}</span>
              </div>
            </div>
            <!-- 余额和限额信息 -->
            <div class="balance-info-section">
              <div class="balance-item">
                <span class="label">{{ $t('investment.available_balance') }}</span>
                <div class="value-group">
                  <span class="amount">{{ formatNumber(productDetail?.user_balance || 0) }} {{ productDetail?.buy_currency?.symbol }}</span>
                  <span class="transfer-btn pointer" @click.stop="transfeShow = true">{{ $t('investment.transfer') }}</span>
                </div>
              </div>
              <div class="balance-item">
                <div class="label-group">
                  <span class="label">{{ $t('investment.current_investment_limit') }}</span>
                  <a-tooltip background-color="#636870">
                    <icon-question-circle-fill class="help-icon"/>
                    <template #content>
                      <span class="tooltip-content">{{ $t('investment.current_investment_tooltip') }}</span>
                    </template>
                  </a-tooltip>
                </div>
                <span class="amount">{{ formatNumber(productDetail?.user_remaining || 0) }} {{ productDetail?.buy_currency?.symbol }}</span>
              </div>
              <!-- 产品申购限额字段已隐藏 -->
              <!-- <div class="balance-item">
                <span class="label">{{ $t('investment.product_subscription_limit') }}</span>
                <span class="amount">{{ formatNumber(productDetail?.remaining || 0) }} {{ productDetail?.buy_currency?.symbol }}</span>
              </div> -->
            </div>
            <!-- 自动续购选项 -->
            <div class="auto-renew-section">
              <div class="auto-renew-item">
                <div class="auto-renew-label">
                  <icon-refresh class="auto-renew-icon"/>
                  <span>{{ $t('investment.auto_renewal') }}</span>
                </div>
                <a-switch v-model="autoRenew" class="auto-renew-switch">
                  <template #checked-icon>
                    <icon-check/>
                  </template>
                  <template #unchecked-icon>
                    <icon-close/>
                  </template>
                </a-switch>
              </div>
            </div>
          </div>
          <div class="flex flex-column align-start con-right">
            <!-- 概览标题 -->
            <div class="overview-header">
              <icon-calendar class="overview-icon"/>
              <span class="overview-title">{{ $t('investment.overview') }}</span>
            </div>
            
            <!-- 时间轴 -->
            <div class="timeline-section">
              <a-timeline class="custom-timeline">
                <a-timeline-item :label="formatDateOnly(new Date())" class="timeline-item">
                  <div class="timeline-content">
                    <div class="timeline-dot"></div>
                    <span class="timeline-text">{{ $t('investment.timeline_subscription_date') }}</span>
                  </div>
                </a-timeline-item>
                <a-timeline-item :label="formatDateOnly(getInterestStartDate())" class="timeline-item">
                  <div class="timeline-content">
                    <div class="timeline-dot"></div>
                    <span class="timeline-text">{{ $t('investment.timeline_interest_start') }}</span>
                  </div>
                </a-timeline-item>
                <a-timeline-item :label="formatDateOnly(getRedemptionDate())" class="timeline-item">
                  <div class="timeline-content">
                    <div class="timeline-dot"></div>
                    <span class="timeline-text">{{ $t('investment.timeline_redemption_date') }}</span>
                  </div>
                </a-timeline-item>
              </a-timeline>
            </div>
            
            <!-- 收益信息 -->
            <div class="profit-info-section">
              <div class="profit-item">
                <div class="profit-label">
                  <icon-trending-up class="profit-icon"/>
                  <span>{{ $t('investment.expected_annual_return_rate') }}</span>
                </div>
                <div class="profit-value">
                  <span class="rate">{{ productDetail?.eay }}%</span>
                </div>
              </div>
              <div class="profit-item">
                <div class="profit-label">
                  <icon-calculator class="profit-icon"/>
                  <span>{{ $t('investment.expected_return') }}</span>
                  <a-tooltip background-color="#636870" position="top">
                    <icon-question-circle-fill class="help-icon" style="margin-left: 4px;"/>
                    <template #content>
                      <div class="formula-tooltip">
                        <div class="formula-title">{{ $t('investment.expected_return_formula') }}</div>
                        <div class="formula-content">{{ $t('investment.expected_return_formula_desc') }}</div>
                      </div>
                    </template>
                  </a-tooltip>
                </div>
                <div class="profit-value">
                  <span class="income">{{ calculateExpectedIncome() }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex align-center mt-10">
          <div class="pointer flex align-center">
            <a-checkbox v-model="agreed" class="mr-5"></a-checkbox>
            <span class="font-14 modal-text mr-5">{{ $t('investment.i_agree') }}</span>
            <span class="font-14 modal-link">{{ $t('investment.term_finance_agreement') }}</span>
          </div>
        </div>
        <div class="flex align-center jus-bet btn-group">
          <a-button @click="visible = false">{{ $t('investment.cancel') }}</a-button>
          <a-button :disabled="!agreed || !subscriptionAmount || showInsufficientBalance" @click="confirmSubscription">{{ $t('investment.confirm') }}</a-button>
        </div>
      </div>
    </a-modal>
    <a-layout-footer>
      <Footer></Footer>
    </a-layout-footer>
    <!-- 资金划转弹窗 -->
    <funds-transfe :visible="transfeShow" @close="transfeShow = false" @success="handleTransferSuccess"></funds-transfe>
  </a-layout>
</template>

<script>
import Footer from "@/components/Footer/footer.vue";
import PageNav from "@/components/PageNav/PageNav.vue";
import fundsTransfe from "@/components/fundsTransfe/fundsTransfe.vue";
import { mapGetters } from 'vuex';
import financingApi from '@/common/api/financing.js';

export default {
  components: {PageNav, Footer, fundsTransfe},
  computed: {
    ...mapGetters(['isLogin', 'accounts']),
    showInsufficientBalance() {
      if (!this.subscriptionAmount || !this.productDetail?.user_balance) {
        return false;
      }
      const amount = parseFloat(this.subscriptionAmount);
      const balance = parseFloat(this.productDetail.user_balance);
      return amount > balance;
    }
  },
  data() {
    return {
      visible: false,
      transfeShow: false,
      radioVal: "1",
      loading: false,
      productDetail: null,
      subscriptionAmount: "",
      autoRenew: false,
      agreed: false
    }
  },
  mounted() {
    this.fetchProductDetail();
  },
  watch: {
    subscriptionAmount() {
      // 当申购金额变化时，实时更新预计收益
      // 这里可以添加额外的验证逻辑
    }
  },
  methods: {
    async fetchProductDetail() {
      try {
        this.loading = true;
        const productId = this.$route.query.id || this.$route.params.id;
        console.log('获取产品详情，产品ID:', productId);
        
        if (!productId) {
          this.$message.error(this.$t('investment.product_id_required'));
          return;
        }
        
        const response = await financingApi.detail({ id: productId });
        console.log('产品详情响应:', response);
        
        if (response && response.data) {
          this.productDetail = response.data;
          console.log('产品详情数据:', this.productDetail);
        } else {
          this.$message.error(this.$t('investment.get_product_details_failed'));
        }
      } catch (error) {
        console.error('获取产品详情失败:', error);
        this.$message.error(this.$t('investment.get_product_details_failed'));
      } finally {
        this.loading = false;
      }
    },
    goBack() {
      this.$router.back()
    },
    radioChange(e) {
      console.log(e);
      this.radioVal = e;
    },
    openSubscription() {
      if (!this.isLogin) {
        this.$message.warning(this.$t('common.please_login'));
        this.$router.push('/Login');
        return;
      }
      this.visible = true;
    },
    async confirmSubscription() {
      if (!this.agreed) {
        this.$message.warning(this.$t('investment.please_agree_first'));
        return;
      }
      
      if (!this.subscriptionAmount || parseFloat(this.subscriptionAmount) <= 0) {
        this.$message.warning(this.$t('investment.please_enter_amount'));
        return;
      }
      
      // 检查余额是否足够
      const amount = parseFloat(this.subscriptionAmount);
      const balance = parseFloat(this.productDetail?.user_balance || 0);
      if (amount > balance) {
        this.$message.warning(this.$t('investment.insufficient_balance'));
        return;
      }
      
      // 检查限购次数
      if (this.productDetail?.limit_times !== undefined && this.productDetail.limit_times !== null && this.productDetail.limit_times > 0) {
        const userPurchaseCount = this.productDetail.user_purchase_count || 0;
        if (userPurchaseCount >= this.productDetail.limit_times) {
          this.$message.warning(this.$t('investment.purchase_limit_reached'));
          return;
        }
      }
      
      try {
        const response = await financingApi.apply({
          financing_product_id: this.productDetail.id,
          amount: this.subscriptionAmount,
          auto_renew: this.autoRenew ? 1 : 0
        });
        
        if (response && response.code === 200) {
          this.$message.success(this.$t('investment.subscription_success'));
          this.visible = false;
          // 重置表单
          this.subscriptionAmount = "";
          this.autoRenew = false;
          this.agreed = false;
          // 刷新产品详情
          this.fetchProductDetail();
        } else {
          this.$message.error(response?.message || this.$t('investment.subscription_failed'));
        }
      } catch (error) {
        console.error('申购失败:', error);
        this.$message.error(this.$t('investment.subscription_failed'));
      }
    },
    getCoinImage(symbol) {
      const coinImages = {
        'USDT': require('@/assets/images/coin/usdt.png'),
        'BTC': require('@/assets/images/coin/btc.png'),
        'ETH': require('@/assets/images/coin/eth.png'),
        'ADA': require('@/assets/images/coin/ada.png'),
        'DOGE': require('@/assets/images/coin/doge.png'),
        'LINK': require('@/assets/images/coin/link.png'),
        'BIB': require('@/assets/images/coin/bib.png')
      };
      
      const upperSymbol = symbol?.toUpperCase();
      return coinImages[upperSymbol] || require('@/assets/images/coin/usdt.png');
    },
    formatNumber(num) {
      if (!num && num !== 0) return '0';
      return parseFloat(num).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 8
      });
    },
    formatDate(dateInput) {
      if (!dateInput) return '--';
      
      let date;
      if (dateInput instanceof Date) {
        date = dateInput;
      } else {
        date = new Date(dateInput);
      }
      
      if (isNaN(date.getTime())) return '--';
      
      // 根据当前语言设置格式化日期
      const currentLang = this.$i18n?.locale || this.$util?.getCache('lang') || 'en-US';
      const localeMap = {
        'zh_CN': 'zh-CN',
        'zh-Hant': 'zh-TW',
        'en-US': 'en-US',
        'ja': 'ja-JP',
        'ko': 'ko-KR',
        'gm': 'de-DE',
        'ru': 'ru-RU',
        'th': 'th-TH',
        'au': 'en-AU'
      };
      const locale = localeMap[currentLang] || 'en-US';
      
      return date.toLocaleString(locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    },
    calculateExpectedIncome() {
      if (!this.subscriptionAmount || !this.productDetail) return '--';
      
      const amount = parseFloat(this.subscriptionAmount);
      const rate = parseFloat(this.productDetail.eay) / 100; // 预期收益率转换为小数（如10%转为0.1）
      
      // 预期收益 = 购买金额 × 预期收益率
      const income = amount * rate;
      return this.formatNumber(income) + ' ' + this.productDetail.buy_currency?.symbol;
    },
    setMaxAmount() {
      if (!this.productDetail) {
        console.warn('产品详情未加载');
        return;
      }
      
      const balance = parseFloat(this.productDetail.user_balance || 0);
      const remaining = parseFloat(this.productDetail.user_remaining || 0);
      
      console.log('设置最大金额:', { balance, remaining, productDetail: this.productDetail });
      
      // 如果余额为0，直接返回
      if (balance <= 0) {
        this.$message.warning(this.$t('investment.insufficient_balance'));
        return;
      }
      
      // 计算最大金额：
      // 1. 如果剩余限额存在且大于0，取余额和限额的较小值
      // 2. 如果剩余限额为0或不存在，只使用余额
      let maxAmount = balance;
      if (remaining > 0) {
        maxAmount = Math.min(balance, remaining);
      }
      
      // 确保不超过余额
      maxAmount = Math.min(maxAmount, balance);
      
      // 如果计算出的金额为0或无效，使用余额
      if (maxAmount <= 0 || isNaN(maxAmount)) {
        maxAmount = balance;
      }
      
      console.log('计算出的最大金额:', maxAmount);
      
      // 保留足够的小数位（根据币种可能需要更多小数位）
      this.subscriptionAmount = maxAmount.toString();
    },
    handleTransferSuccess() {
      // 划转成功后刷新产品详情，更新余额信息
      this.fetchProductDetail();
    },
    getInterestStartDate() {
      // 起息日 = 申购日 + 1天 + 12小时
      const today = new Date();
      const interestStartDate = new Date(today);
      interestStartDate.setDate(today.getDate() + 1);
      interestStartDate.setHours(12, 0, 0, 0);
      return interestStartDate;
    },
    getRedemptionDate() {
      // 赎回日 = 到期日 + 1天 = 起息日 + 产品期限 + 1天
      if (!this.productDetail?.time_limit) {
        return new Date();
      }
      const interestStartDate = this.getInterestStartDate();
      const redemptionDate = new Date(interestStartDate);
      redemptionDate.setDate(interestStartDate.getDate() + this.productDetail.time_limit + 1);
      redemptionDate.setHours(12, 0, 0, 0);
      return redemptionDate;
    },
    formatDateOnly(dateInput) {
      if (!dateInput) return '--';
      
      let date;
      if (dateInput instanceof Date) {
        date = dateInput;
      } else {
        date = new Date(dateInput);
      }
      
      if (isNaN(date.getTime())) return '--';
      
      // 根据当前语言设置格式化日期
      const currentLang = this.$i18n?.locale || this.$util?.getCache('lang') || 'en-US';
      const localeMap = {
        'zh_CN': 'zh-CN',
        'zh-Hant': 'zh-TW',
        'en-US': 'en-US',
        'ja': 'ja-JP',
        'ko': 'ko-KR',
        'gm': 'de-DE',
        'ru': 'ru-RU',
        'th': 'th-TH',
        'au': 'en-AU'
      };
      const locale = localeMap[currentLang] || 'en-US';
      
      return date.toLocaleDateString(locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    },
    formatContent(content) {
      if (!content) return '';
      
      // 如果content是HTML格式，直接返回
      if (content.includes('<') && content.includes('>')) {
        return content;
      }
      
      // 如果是纯文本，按换行符分割并包装成p标签
      const lines = content.split('\n').filter(line => line.trim());
      return lines.map(line => `<p class="font-14 color-gray">${line}</p>`).join('');
    },
    getRemainingPurchases() {
      if (!this.productDetail) return 0;
      const limitTimes = this.productDetail.limit_times || 0;
      if (limitTimes === 0) return '∞'; // 不限制
      const userPurchaseCount = this.productDetail.user_purchase_count || 0;
      const remaining = limitTimes - userPurchaseCount;
      return remaining > 0 ? remaining : 0;
    }
  }
}
</script>

<style scoped lang="scss">
@import "./detail.scss";
</style>